import { withStyles } from '@material-ui/core/styles'
import { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import { PrimaryButton, SecondaryButtonLight } from '../Button'
import { Text } from '../Typography'

const styles = () => ({
  root: {
    zIndex: 10,
    width: '100%',
    position: 'fixed',
    transition: 'bottom 300ms linear',
    left: 0,
    right: 0,
    bottom: '-69px',
    backgroundColor: `var(--gameday-miscComponents-dockingFooterBg, ${theme.miscComponents.dockingFooterBg});`,
    padding: 0,
    boxSizing: 'border-box',
  },
  floatingStyle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    padding: theme.spacing(4),
  },
  primeBtn: {
    borderColor: 'transparent',
    width: '120px',
    height: '36px',
    display: 'flex',
    float: 'right',
    marginLeft: '16px',
    marginRight: '64px',
  },
  secBtn: {
    borderColor: theme.colors.white,
    color: theme.colors.white,
    float: 'right',
    width: '120px',
    height: '36px',
    display: 'flex',
    '& .textSpacing': {
      marginRight: '5px',
    },
  },
  heightFix: {
    height: '72px',
    width: '100%',
    float: 'left',
  },
})

const FloatFooter = ({
  classes,
  handleCancel,
  handleSave,
  cancelText,
  saveText,
  errorMessage,
  isError,
  show,
  showCancel,
}) => {
  const visible = { bottom: '0px' }
  return (
    // show && <div className={classes.heightFix} style={show ? {display: 'hidden' } : null}></div>,
    <ThemeProvider theme={theme}>
      <div className={classes.root} style={show || showCancel ? visible : null}>
        {show || isError ? (
          <div className={classes.floatingStyle} style={{ bottom: 0 }}>
            {isError && (
              <Text style={{ color: '#e74c3c' }}>An error has occurred: {errorMessage}, Please try again later.</Text>
            )}
            {handleCancel && (
              <SecondaryButtonLight className={classes.secBtn} onClick={handleCancel} data-testid="cancelModalButton">
                {cancelText}
              </SecondaryButtonLight>
            )}
            <PrimaryButton
              className={classes.primeBtn}
              onClick={handleSave}
              aria-label={saveText}
              data-testid="saveModalButton"
            >
              {saveText}
            </PrimaryButton>
          </div>
        ) : null}
        {!show && showCancel && handleCancel && (
          <div className={classes.floatingStyle} style={{ bottom: 0 }}>
            <SecondaryButtonLight className={classes.secBtn} onClick={handleCancel} aria-label={cancelText}>
              {cancelText}
            </SecondaryButtonLight>
          </div>
        )}
      </div>
    </ThemeProvider>
  )
}

FloatFooter.defaultProps = {
  cancelText: 'Cancel',
  saveText: 'Save',
}

const DockingFooter = withStyles(styles)(FloatFooter)
DockingFooter.displayName = 'DockingFooter'
export default DockingFooter
